export default __webpack_public_path__ + "static/media/showimage.4c6a403d.jpg";